import { CheckCircleOutlined, WarningOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { Flex, Typography } from '../../designComponents';
export const ComplianceSectionStyled = styled.section`
  max-width: 960px;
  margin: 0 auto;
  padding: 80px 20px;
  text-align: center;

  .section-title {
    margin-bottom: 16px;
  }

  .section-desc {
    max-width: 720px;
    margin: 0 auto 32px;
  }

  svg {
    font-size: 18px;
  }

  .warning-box {
    background: #fff7e6;
    border: 1px solid #ffd591;
    border-radius: 8px;
    padding: 16px;
    align-items: flex-start;
  }

  details {
    margin-top: 24px;
    cursor: pointer;
  }

  summary {
    list-style: none;
  }

  summary::-webkit-details-marker {
    display: none;
  }
`;
const ComplianceSection = () => {
  return (
    <ComplianceSectionStyled>
      <Typography strong size={28} className="section-title">
        Do I legally need fire escape plans?
      </Typography>

      <Typography size={16} className="section-desc">
        Yes — in most commercial and multi-occupancy buildings, fire escape
        plans must be clearly displayed.
      </Typography>

      <Typography strong size={18} margin="24px 0 12px">
        Fire officers, insurers, and local authorities expect:
      </Typography>

      <Flex direction="column" gap="12px">
        <Flex gap="10px">
          <CheckCircleOutlined />
          <Typography>Accurate floor layouts</Typography>
        </Flex>
        <Flex gap="10px">
          <CheckCircleOutlined />
          <Typography>Clear escape routes</Typography>
        </Flex>
        <Flex gap="10px">
          <CheckCircleOutlined />
          <Typography>Assembly points</Typography>
        </Flex>
        <Flex gap="10px">
          <CheckCircleOutlined />
          <Typography>Fire equipment locations</Typography>
        </Flex>
      </Flex>

      <Flex
        direction="column"
        gap="10px"
        className="warning-box"
        margin="24px 0"
      >
        <Flex gap="10px">
          <WarningOutlined />
          <Typography>Delay certification</Typography>
        </Flex>
        <Flex gap="10px">
          <WarningOutlined />
          <Typography>Invalidate insurance</Typography>
        </Flex>
        <Flex gap="10px">
          <WarningOutlined />
          <Typography>Fail inspections</Typography>
        </Flex>
      </Flex>

      {/* Expandable / Accordion */}
      <details className="who-applies">
        <summary>
          <Typography strong>Who this applies to</Typography>
        </summary>
        <Flex direction="column" gap="8px" margin="12px 0 0">
          <Typography>Hotels & guesthouses</Typography>
          <Typography>Construction sites</Typography>
          <Typography>Offices & warehouses</Typography>
          <Typography>Apartment blocks</Typography>
          <Typography>Retail units</Typography>
        </Flex>
      </details>
    </ComplianceSectionStyled>
  );
};

export default ComplianceSection;
